import { HttpResponse } from './HttpResponse';
import { MessagePackage } from '../Storage/Messages/MessagePackage';
import { IMessage } from './IMessage';
import { ISender } from './ISender';
import { MessageBusResponse } from './MessageBusResponse';

/*
    SAMPLE POST:

    {
        "Sender": { 
            "Id": "guid", 
            "AuthToken": "token" 
        },
        "Message": {
            "Name": "Update",
            "Body": {
                "Id": "number"
                "Content": { "foo": "bar" },
                "CreateIfNotExist": false
            }
        }
    }
*/

export class MessageBus
{
    constructor(
        private serverUrl,
        private user?: ISender | undefined)
    { }

    public async SendMessage(message: IMessage): Promise<MessageBusResponse>
    {
        let messagePackage = new MessagePackage();
        messagePackage.Message = message;
        messagePackage.Sender = this.user || { Id: "Anonymous" };

        return await this.SendMessagePackage(messagePackage);
    }

    private async PostJSON(data: any): Promise<HttpResponse>
    {
        const httpResponse = new HttpResponse();
        const dataAsString = JSON.stringify(data);
        const response = await fetch(this.serverUrl, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: dataAsString,
        });

        httpResponse.status = response.status;
        const json = await response.json();
        httpResponse.data = json;
        return httpResponse;
    }

    public async Ping(): Promise<boolean>
    {
        try
        {
            const response = await fetch(this.serverUrl + "/ping", {
                method: "GET",
            });
            
            return response.status == 200 && await response.text() == "pong";
        }
        catch (ex: any)
        {
            return false;
        }
    }

    private async SendMessagePackage(messagePackage: MessagePackage): Promise<MessageBusResponse>
    {
        try
        {
            // console.log(`[OnlineStorage] ${JSON.stringify(messagePackage)} --> ${this.serverUrl}`);

            const response = await this.PostJSON(messagePackage);

            if (response.status == 200 && response.data.IsSuccess == true)
            {
                const result = response.data as MessageBusResponse;

                // console.log(`[OnlineStorage] ✅ Result: ${JSON.stringify(result.Result)}`);

                return MessageBusResponse.Success(result.Result);
            }
            else if (response.status == 200 && response.data.IsSuccess == false)
            {
                console.log(`❌ Operation failure: ${JSON.stringify(response)}`);
                return MessageBusResponse.Fault(response.status, response.data.ErrorMessage);
            }

            console.log(`❌ Response: ${JSON.stringify(response)}`);
            return MessageBusResponse.Fault(response.status, "Non-200 Status");
        }
        catch (ex: any)
        {
            if (ex.message == 'Failed to fetch')
            {
                console.log(`❌ Internet connection problem: ${ex.message}`);

                return MessageBusResponse.Fault(ex.response?.status, ex.message);
            }

            console.log(`❌ Exception: ${ex.message} | HTTP ${ex.response?.status}`);
            return MessageBusResponse.Fault(ex.response?.status, ex.message);
        }
    }
}
